import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index.component';
import { DatePickerAtomModule } from './../../components/atoms/date-picker/date-picker.module';
import { CardAtomModule } from './../../components/atoms/card/card.module';
import { TableHeaderAtomModule } from './../../components/atoms/table-header/table-header.module';
import { CheckboxAtomModule } from './../../components/atoms/checkbox/checkbox.module';
import { RadioButtonAtomModule } from './../../components/atoms/radio-button/radio-button.module';
import { InputAtomModule } from './../../components/atoms/input/input.module';
import { ButtonAtomModule } from './../../components/atoms/button/button.module';
import { SelectAtomModule } from './../../components/atoms/select/select.module';
import { StepperAtomModule } from './../../components/atoms/stepper/stepper.module';
import { PaginationAtomModule } from './../../components/atoms/pagination/pagination.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ImageAtomModule } from './../../components/atoms/image/image.module';
import { ProfileOutOfOfficeModalModule } from './../../modals/profile-out-of-office-modal/profile-out-of-office-modal.module';
import { AutoCompleteAtomModule } from './../../components/atoms/auto-complete/auto-complete.module';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'src/app/components/atoms/multi-select/multi-select.module';
import { InputCurrencyModule } from 'src/app/components/atoms/input-currency/input-currency.module';

@NgModule({
  declarations: [IndexComponent],
  imports: [
    CommonModule,
    RouterModule,
    DatePickerAtomModule,
    CardAtomModule,
    TableHeaderAtomModule,
    CheckboxAtomModule,
    RadioButtonAtomModule,
    InputAtomModule,
    ButtonAtomModule,
    SelectAtomModule,
    StepperAtomModule,
    PaginationAtomModule,
    MatTooltipModule,
    ImageAtomModule,
    ProfileOutOfOfficeModalModule,
    AutoCompleteAtomModule,
    ReactiveFormsModule,
    MultiSelectModule,
    InputCurrencyModule
  ],
  exports: [IndexComponent]
})
export class IndexScreenModule { }
